import { z } from 'zod';

const ExternalLinkCommentEngagementSchema = z
  .object({
    likes: z.number().int().min(0).optional(),
    quotes: z.number().int().min(0).optional(),
    replies: z.number().int().min(0).optional(),
  })
  .strip()
  .optional();

export const ExternalLinkTopCommentSchema = z
  .object({
    tweetId: z.string().min(1),
    authorHandle: z.string().min(1).optional(),
    comment: z.string().min(1),
    engagement: ExternalLinkCommentEngagementSchema,
  })
  .strip();

export const ExternalLinkSummaryItemSchema = z
  .object({
    url: z.string().url(),
    canonicalUrl: z.string().url().optional(),
    domain: z.string().min(1).optional(),
    title: z.string().optional(),
    snippet: z.string().optional(),
    summary: z.string().optional(),
    siteName: z.string().optional(),
    language: z.string().optional(),
    shareCount: z.number().int().min(0).optional(),
    tweetHandles: z.array(z.string().min(1)).max(10).optional(),
    tweetIds: z.array(z.string().min(1)).max(20).optional(),
    imageUrl: z.string().url().optional(),
    topComments: z.array(ExternalLinkTopCommentSchema).max(5).optional(),
    fetchedAt: z.date().optional(),
    cacheHit: z.boolean().optional(),
    score: z.number().min(0).optional(),
    contentHash: z.string().optional(),
    warnings: z.array(z.string()).optional(),
  })
  .strip();

export type ExternalLinkTopComment = z.infer<typeof ExternalLinkTopCommentSchema>;

export type ExternalLinkSummaryItem = z.infer<typeof ExternalLinkSummaryItemSchema>;

export const ExternalLinkContentMetadataSchema = z
  .object({
    fetched: z.boolean().optional(),
    limit: z.number().int().min(0).max(50).optional(),
    items: z.array(ExternalLinkSummaryItemSchema).max(50).optional(),
    warnings: z.array(z.string()).optional(),
    fetchedAt: z.date().optional(),
    totalLinks: z.number().int().min(0).optional(),
    truncated: z.boolean().optional(),
    durationMs: z.number().min(0).optional(),
    gated: z.boolean().optional(),
  })
  .passthrough()
  .nullable()
  .optional();

export type ExternalLinkContentMetadata = z.infer<typeof ExternalLinkContentMetadataSchema>;
